import Flickity from 'flickity';

window.addEventListener('load', function () {
    if (typeof Flickity === 'undefined') return;

    // ----------------------------------------
    // 共通：.swipe_wrap は PC・スマホどちらでも常に発火
    // ----------------------------------------
    const swipeElems = document.querySelectorAll('.swipe_wrap');
    if (!swipeElems || swipeElems.length === 0) {
        // 対象要素がない場合は何もしない
    } else {
        swipeElems.forEach((elem) => {
            if (!elem) return;

            // 既に初期化されている場合はスキップ（多重初期化防止）
            if (Flickity.data(elem)) return;

            // PC・スマホ共通の設定
            const flkty = new Flickity(elem, {
                cellAlign: 'left',
                contain: true
            });
        });
    }

    // ----------------------------------------
    // ブレイクポイント判定
    // ----------------------------------------
    const mql = window.matchMedia('(max-width: 480px)');
    let isMobile = mql.matches;

    /**
     * トップ Update: 装飾 .top-eventTag を、選択中スライドが Event カードのときだけ表示
     */
    function bindTopUpdateEventTagSync(flkty, elem) {
        const wrap = elem.closest('[data-top-update-slider]');
        if (!wrap) return;
        const tag = wrap.querySelector('.top-eventTag');
        if (!tag) return;

        const sync = () => {
            const cell = flkty.selectedElement;
            const show = !!(cell && cell.classList.contains('-event'));
            tag.classList.toggle('top-eventTag--sliderHide', !show);
        };

        flkty.on('select', sync);
        flkty.on('settle', sync);
        sync();
    }

    /**
     * スマホ状態に応じて .swipe_wrap_sp を初期化／破棄
     * @param {boolean} enableMobile - true: スマホとして有効化、false: 無効化
     */
    function handleMobileSliders(enableMobile) {
        const mobileElems = document.querySelectorAll('.swipe_wrap_sp');
        if (!mobileElems || mobileElems.length === 0) {
            return;
        }

        mobileElems.forEach((elem) => {
            if (!elem) return;
            const instance = Flickity.data(elem);

            if (enableMobile) {
                if (instance) return;

                const flktyMobile = new Flickity(elem, {
                    cellAlign: 'center',
                    contain: true,
                    pageDots: false,
                    prevNextButtons: true
                });
                bindTopUpdateEventTagSync(flktyMobile, elem);
            } else {
                if (instance) {
                    const wrap = elem.closest('[data-top-update-slider]');
                    if (wrap) {
                        const tag = wrap.querySelector('.top-eventTag');
                        if (tag) {
                            tag.classList.remove('top-eventTag--sliderHide');
                        }
                    }
                    instance.destroy();
                }
            }
        });
    }

    handleMobileSliders(isMobile);

    // ----------------------------------------
    // リサイズ時の処理
    // ----------------------------------------
    window.addEventListener('resize', () => {
        const currentIsMobile = mql.matches;

        if (currentIsMobile === isMobile) {
            return;
        }

        isMobile = currentIsMobile;
        handleMobileSliders(isMobile);
    });
});
